import React, { useEffect, useState, forwardRef } from "react";
import Div from "../../../../../../shared/ui/Div";
import { FormControlLabel, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, Button } from "@mui/material";
import styles from "./styles";

interface ICheckBoxListProps {
  label: string;
  defaultChecked: boolean;
  children: React.ReactNode;
  onChange: (value: boolean) => void;
  fromApi?: boolean;
}

const CheckboxList = forwardRef<HTMLDivElement, ICheckBoxListProps>((props, ref) => {
  const { label, defaultChecked, children, onChange, fromApi = false } = props;
  const [checked, setChecked] = useState<boolean>(defaultChecked);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [initialRender, setInitialRender] = useState<boolean>(true);

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      return;
    }
    onChange(checked);
  }, [checked]);

  const handleCheckboxChange = () => {
    if (checked && fromApi && !initialRender) {
      setOpenDialog(true);
    } else {
      setChecked(prev => !prev);
    }
  };

  const handleConfirmUncheck = () => {
    setChecked(false);
    setOpenDialog(false);
  };

  const handleCancelUncheck = () => {
    setOpenDialog(false);
  };

  return (
    <Div sx={styles.container} ref={ref}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={handleCheckboxChange}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        }
        label={label}
      />
      {checked && children}

      <Dialog
        open={openDialog}
        onClose={handleCancelUncheck}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            If you remove the assignment from this class, any student responses will be lost.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelUncheck} sx={styles.cancelButton}>Cancel</Button>
          <Button onClick={handleConfirmUncheck} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </Div>
  );
});

export default CheckboxList;
